import { render, staticRenderFns } from "./out_stock_form.vue?vue&type=template&id=70b6d49a&scoped=true&"
import script from "./out_stock_form.vue?vue&type=script&lang=js&"
export * from "./out_stock_form.vue?vue&type=script&lang=js&"
import style0 from "./out_stock_form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./out_stock_form.vue?vue&type=style&index=1&id=70b6d49a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6d49a",
  null
  
)

export default component.exports